import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class MLSListingService {
    searchDetails: any;

    constructor(private http: HttpClient, private router: Router) {}

    getAgentListings(id) {
        var auth = btoa("info_2085r540:283662y91082xe9x");
        console.log("id", id);
        var url =
            "https://api.simplyrets.com/properties?status=Active&agent=" +
            id +
            "&count=true";
        console.log(auth);
        var headers = {
            headers: new HttpHeaders().set("Authorization", "Basic " + auth),
        };
        return this.http.get(url, headers);
    }

    getStrideListings(all_ids) {
        var auth = btoa("info_2085r540:283662y91082xe9x");
        var url =
            "https://api.simplyrets.com/properties?status=Active" +
            all_ids +
            "&count=true";
        var headers = {
            headers: new HttpHeaders().set("Authorization", "Basic " + auth),
        };
        return this.http.get(url, headers);
    }

    getListingDetails(listing_id) {
        var auth = btoa("info_2085r540:283662y91082xe9x");
        var url = "https://api.simplyrets.com/properties?q=" + listing_id;
        var headers = {
            headers: new HttpHeaders().set("Authorization", "Basic " + auth),
        };
        return this.http.get(url, headers);
    }

    getSearchResults(search_arg) {
        // console.log(search_arg);
        var auth = btoa("info_2085r540:283662y91082xe9x");
        var address_components = search_arg.address_components.slice(0, 2);
        console.log(address_components);
        if (address_components[0].types[0] == "locality") {
            var search_query = address_components[0].long_name;
        } else if (address_components[0].types[0] == "postal_code") {
            search_query = address_components[0].long_name;
        } else if (address_components[0].types[0] == "route") {
            var replaceString = / /gi;
            search_query = address_components[0].long_name.replace(
                replaceString,
                "%20"
            );
            // console.log(search_query);
        } else if (address_components[0].types[0] == "street_number") {
            var replaceString = / /gi;
            search_query =
                address_components[0].long_name +
                "%20" +
                address_components[1].long_name.replace(replaceString, "%20");
            console.log(search_query);
        }
        // var fulladdress = search_arg.name.split(" ");
        // var city = search_arg.vicinity;
        //console.log(fulladdress);
        //console.log(city);
        var url =
            "https://api.simplyrets.com/properties?q=" +
            search_query +
            "&status=Active&count=true";
        //console.log(url);
        var headers = {
            headers: new HttpHeaders().set("Authorization", "Basic " + auth),
        };
        return this.http.get(url, headers);
    }

    setSearchResults(userObject) {
        this.searchDetails = userObject;
        // localStorage.setItem('searchResults', userObject);
        this.router.navigate(["/" + "search-results"]);
    }

    getSavedSearchResults() {
        // this.searchDetails = localStorage.getItem('searchResults');
        // console.log(this.searchDetails);
        return this.searchDetails;
    }

    advancedSearch(locality, minbaths, minbeds, minprice, maxprice) {
        var auth = btoa("info_2085r540:283662y91082xe9x");
        var url =
            "https://api.simplyrets.com/properties?q=" +
            locality +
            "&minprice=" +
            minprice +
            "&maxprice=" +
            maxprice +
            "&minbaths=" +
            minbaths +
            "&minbeds=" +
            minbeds +
            "&maxbeds=" +
            minbeds +
            "&count=true";
        var headers = {
            headers: new HttpHeaders().set("Authorization", "Basic " + auth),
        };
        return this.http.get(url, headers);
    }
}
